import styled from 'styled-components';

export const WrapperSelect = styled.div`
  width: 100%;
`;

export const WrapperSelectLabel = styled.label<{
  disabled?: boolean;
}>`
  cursor: pointer;
  margin-bottom: 8px;
  // width: max-content;
  display: block;
  color: ${(props) => (props.disabled ? '#8090BB' : '#161D1F')};
`;

export const WrapperSelectRelative = styled.div<{
  disabled?: boolean;
}>`
  color: ${(props) => (props.disabled ? '#8090BB' : '#161D1F')};
  position: relative;
  width: 100%;

  & .errorText {
    display: flex;
    font-size: 12px !important;
    align-items: flex-start;
    margin-top: 3px;

    cc-icon {
      margin-top: 2px;
    }
  }
`;

const getBorderColor = (props: { disabled?: boolean; error?: boolean }) => {
  if (props.disabled) return '#7a959f';
  if (props.error) return '#E8212B';
  return '#161d1f';
};

export const WrapperSelectButton = styled.button<{
  isActive?: boolean;
  disabled?: boolean;
  isSelected?: boolean;
  error?: boolean;
}>`
  background-color: #fff;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  height: 40px;
  width: 100%;
  padding: 0 8px 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid ${(props) => getBorderColor(props)};
  border-radius: 4px;

  > span {
    font-size: 14px;
    color: ${(props) => getBorderColor(props)};
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  > div {
    height: 24px;
    width: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    background-color: transparent;

    > cc-icon,
    > cc-loader {
      color: ${(props) => (props.disabled ? '#8090BB' : '#5b36f2')};
    }
  }

  &:hover {
    border: 1px solid #745ef6;

    > div {
      background-color: #e2dffd;
    }
  }

  &:focus,
  &:active {
    border: 1px solid #4318cd;

    > div {
      background-color: #c6c0fc;
    }
  }

  &:disabled {
    border: 1px solid #7a959f;

    > div {
      background-color: transparent;
    }
  }
`;

export const WrapperSelectItems = styled.div<{
  isActive: boolean;
  isTop: boolean;
  itemCount: number;
}>`
  position: ${(props) => (props.isTop ? 'none' : 'absolute')};
  z-index: 1;
  ${(props) => (props.isTop ? 'bottom' : 'top')}: calc(100% + 4px);
  left: 0;
  max-height: ${(props) => `${16 + 40 * props.itemCount}px`};
  width: 100%;
  padding: 8px 0;
  display: ${(props) => (props.isActive ? 'block' : 'none')};
  border-radius: 4px;
  background-color: #ffffff;
  overflow-y: auto;
  box-shadow: 0px 5px 8px rgba(74, 74, 74, 0.22);
  top: 42px;
`;

export const WrapperSelectItem = styled.button<{
  isActive: boolean;
}>`
  height: 40px;
  width: 100%;
  padding: 0 16px;
  display: flex;
  align-items: center;
  background-color: ${(props) => (props.isActive ? '#E2DFFD' : 'transparent')};

  &:hover {
    background-color: #d5e5f0;
  }

  &:focus,
  &:active {
    background-color: #a8cbe2;
  }

  > span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;
